import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBreakpoints from 'hooks/useBreakpoints';
import Heading from 'components/Heading';
import Card from 'components/Card';
import UserGeneratedText from 'components/UserGeneratedText';
import Flag from 'components/Flag';
import IconDisc from 'components/IconDisc';
import Box from 'components/Box';
import Button from 'components/Button';
import PercentageDisc from 'components/PercentageDisc';
function SummaryFlagCard(_ref) {
  var titleId = _ref.titleId,
    summary = _ref.summary,
    subtitle = _ref.subtitle,
    score = _ref.score,
    link = _ref.link,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  return /*#__PURE__*/React.createElement(Flag, {
    token: score || score === 0 ? /*#__PURE__*/React.createElement(PercentageDisc, {
      shady: true,
      percentage: score
    }) : isDesktop && /*#__PURE__*/React.createElement(IconDisc, {
      size: "big",
      shady: true,
      name: "asset-activity"
    }),
    align: "top"
  }, /*#__PURE__*/React.createElement(Card, {
    px: "m",
    py: "s"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    mb: subtitle ? 'xxs' : 's',
    id: titleId
  }, t('property_summary')), subtitle && /*#__PURE__*/React.createElement(Box, {
    dimmed: true,
    fontSize: "s",
    mb: "s"
  }, subtitle), /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: summary
  }), children), link && /*#__PURE__*/React.createElement(Button, {
    as: Link,
    mt: "s",
    variant: "primary",
    size: "medium",
    iconRight: "arrow-right",
    to: link
  }, t('actions_view_full_analysis')));
}
export default SummaryFlagCard;